import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Fade,
  Zoom,
  Box,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SuccessPopup = ({ 
  open, 
  onClose, 
  title = "Files Uploaded Successfully!", 
  message = "Your documents have been uploaded and are ready for classification.",
  buttonText = "Thank You!",
  onButtonClick,
  redirectTo = null
}) => {
  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          overflow: 'hidden'
        }
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        <Fade in={open} timeout={800}>
          <Box>
            <Zoom in={open} timeout={1000} style={{ transitionDelay: '200ms' }}>
              <CheckCircleIcon 
                sx={{ 
                  fontSize: 80, 
                  color: '#4CAF50',
                  mb: 2,
                  filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))'
                }} 
              />
            </Zoom>
            
            <Fade in={open} timeout={1200} style={{ transitionDelay: '400ms' }}>
              <Typography variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
                {title}
              </Typography>
            </Fade>
            
            <Fade in={open} timeout={1400} style={{ transitionDelay: '600ms' }}>
              <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
                {message}
              </Typography>
            </Fade>
            
            <Fade in={open} timeout={1600} style={{ transitionDelay: '800ms' }}>
              <Button
                variant="contained"
                onClick={handleButtonClick}
                sx={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: '25px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  boxShadow: '0 4px 12px rgba(76, 175, 80, 0.4)',
                  '&:hover': {
                    backgroundColor: '#45a049',
                    boxShadow: '0 6px 16px rgba(76, 175, 80, 0.6)',
                    transform: 'translateY(-2px)',
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                {buttonText}
              </Button>
            </Fade>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessPopup;
